import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VRow,{staticClass:"my-12 py-12",attrs:{"justify":"center","align":"center"}},[_c(VCol,{staticClass:"d-flex justify-center",attrs:{"cols":"12"}},[_c(VIcon,{attrs:{"x-large":""}},[_vm._v("mdi-alert-rhombus-outline")])],1),_c(VCol,{staticClass:"d-flex justify-center",attrs:{"cols":"12"}},[_c('h3',[_vm._v("Error occurred. Please refresh the page.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }